var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIkfIcon4Section4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 53,
    viewBox: "0 0 52 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_133_946)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.71094,
    y: 0.46875,
    width: 46.178,
    height: 46.178,
    rx: 23.089,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.92815,
    y: 0.685964,
    width: 45.7436,
    height: 45.7436,
    rx: 22.8718,
    stroke: "#D9F4FF",
    strokeWidth: 0.434429
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6449 17.7764V31.6539C35.6443 31.8582 35.5653 32.0539 35.4251 32.1984C35.2849 32.3428 35.0949 32.4242 34.8966 32.4248H18.4341L16.9375 31.6539V17.7764H35.6449Z",
    fill: "#5AAAE7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2841 25.0999C32.2841 26.5313 31.7322 27.904 30.7499 28.916C29.7676 29.9281 28.4352 30.4967 27.046 30.4967C26.9188 30.4967 26.7953 30.4929 26.6719 30.4813C27.9888 30.3785 29.2195 29.767 30.1174 28.7691C31.0154 27.7712 31.5143 26.4607 31.5143 25.0999C31.5143 23.7392 31.0154 22.4287 30.1174 21.4308C29.2195 20.4329 27.9888 19.8213 26.6719 19.7185C26.7953 19.707 26.9188 19.7031 27.046 19.7031C28.4352 19.7031 29.7676 20.2717 30.7499 21.2838C31.7322 22.2959 32.2841 23.6686 32.2841 25.0999Z",
    fill: "#3D9AE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6449 15.4634V17.7763H16.9375V15.4634L18.4341 14.6924H34.8966C35.0949 14.693 35.2849 14.7744 35.4251 14.9189C35.5653 15.0633 35.6443 15.2591 35.6449 15.4634Z",
    fill: "#FF5023"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5614 12.3789H18.8131L18.439 13.1499V14.6918L16.9424 15.4628L15.4458 14.6918V13.1499L15.0717 12.3789H14.3234L13.9492 13.1499V16.2338L15.4458 17.7757V29.3403L13.9492 30.8822V33.9661L14.3234 34.7371H15.0717L15.4458 33.9661V32.4242L16.9424 31.6532L18.439 32.4242V33.9661L18.8131 34.7371H19.5614L19.9356 33.9661V32.4242V30.8822L18.439 29.3403V17.7757L19.9356 16.2338V14.6918V13.1499L19.5614 12.3789Z",
    fill: "#00CCB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4414 29.341L19.938 30.8829V32.4248H20.6863V30.8829L19.1897 29.341V17.7764H18.4414V29.341Z",
    fill: "#3D9AE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6863 14.6924H19.938V16.2343L18.4414 17.7763H19.1897L20.6863 16.2343V14.6924Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2928 30.4967C29.1857 30.4967 31.5308 28.0805 31.5308 25.0999C31.5308 22.1194 29.1857 19.7031 26.2928 19.7031C23.3999 19.7031 21.0547 22.1194 21.0547 25.0999C21.0547 28.0805 23.3999 30.4967 26.2928 30.4967Z",
    fill: "#FFD422"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0754 27.2547C26.0062 27.3262 25.924 27.3829 25.8335 27.4215C25.7429 27.4602 25.6459 27.4801 25.5479 27.4801C25.4499 27.4801 25.3528 27.4602 25.2623 27.4215C25.1718 27.3829 25.0896 27.3262 25.0203 27.2547L23.6959 25.8901C23.6263 25.8184 23.5712 25.7334 23.5336 25.6398C23.4959 25.5462 23.4766 25.4459 23.4766 25.3446C23.4766 25.2433 23.4959 25.143 23.5336 25.0494C23.5712 24.9558 23.6263 24.8708 23.6959 24.7991C23.8363 24.6545 24.0267 24.5732 24.2253 24.5732C24.3236 24.5732 24.421 24.5931 24.5118 24.6319C24.6026 24.6707 24.6852 24.7275 24.7547 24.7991L25.5479 25.6164L28.1931 22.891C28.3335 22.7463 28.524 22.665 28.7225 22.665C28.9211 22.665 29.1115 22.7463 29.252 22.891C29.3924 23.0356 29.4713 23.2319 29.4713 23.4364C29.4713 23.641 29.3924 23.8372 29.252 23.9819L26.0754 27.2547Z",
    fill: "#FF5023"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0352 15.8486H30.7835V16.6196H30.0352V15.8486Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5352 15.8486H32.2835V16.6196H31.5352V15.8486Z",
    fill: "#ED1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0312 15.8486H33.7795V16.6196H33.0312V15.8486Z",
    fill: "#ED1C24"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_133_946",
    x: 0.352761,
    y: 0.46875,
    width: 51.6124,
    height: 51.6104,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.35818,
    dy: 2.71635
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.35818
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0509804 0 0 0 0 0.431373 0 0 0 0 0.709804 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_133_946"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_133_946",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIkfIcon4Section4);
export default __webpack_public_path__ + "static/media/ikf_icon4_section4.cc6a9f5706d7980a53f20b63f645f047.svg";
export { ForwardRef as ReactComponent };